import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, onMounted, ref } from "vue";
import * as API_goods from "@/api/goods";
import { getShopDetailByShopName } from "@/api/supplier-entry";


export default /*#__PURE__*/_defineComponent({
  __name: 'merchants',
  props: {
  tip: {
    type: Boolean,
    default: true
  }
},
  setup(__props, { expose }) {

const prop = __props;

const fileUrl = ref("");
const fileName = ref("");
const loading = ref(false);
const dialogImageUrl = ref("");
const dialogImage = ref(false);
/** 点击已上传的文件链接时的钩子 放大 */
const handlePictureCardPreview = (file) => {
  dialogImageUrl.value = file;
  dialogImage.value = true;
}
const getShop = async () => {
  try {
    loading.value = true;
    const res = await getShopDetailByShopName();
    form.value = res.data;
    fileUrl.value = res.data.electronic_contract_file
    fileName.value = res.data.electronic_contract_file_name
    loading.value = false;
  } catch (error) {
    loading.value = false;
    console.log(error)
  }
}
onMounted(() => {
  getShop()
});

const openFile = () => {
  if (!fileUrl.value) return
  window.open(`https://view.officeapps.live.com/op/view.aspx?src=` + fileUrl.value);
}


const downloadFile = () => {
  if (!fileUrl.value) return
  const link = document.createElement('a')
  link.href = fileUrl.value.replace('http://', 'https://')
  link.download = fileName.value || '店铺合同文件' // 设置下载文件名
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const formRef = ref<any>(null);
const provinceList = ref<{ name: string; id: number }[]>([]);
const cityList = ref<{ name: string; id: number }[]>([]);
const countyList = ref<{ name: string; id: number }[]>([]);
const townList = ref<{ name: string; id: number }[]>([]);
const address = ref({
  receive_county_id: "",
  receive_address: "",
  receive_town: "",
  receive_province_id: "",
  receive_city_id: "",
  receive_town_id: "",
  receive_city: "",
  receive_county: "",
  receive_province: "",
});

const form = ref({
  shop_type: "",
  shop_name: "",
  office_address_info: '',
  office_address: "",
  product_category: '',
  company_description: '',
  email: '',
  business_license: '',
  trademark_certificate: '',
  company_head_name: '',
  company_head_contact: '',
  mobile: '',
});
const rules = {
  shop_type: [
    { required: true, message: "请选择商家店铺类型", trigger: "change" }
  ],
  shop_name: [
    { required: true, message: "请输入商家店铺名称", trigger: "blur" }
  ],
  office_address_info: [
    { required: true, message: "请输入公司办公地址", trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        if (!address.value.receive_county_id) {
          callback(new Error("请选择公司办公地址"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
  product_category: [
    { required: true, message: "请选择所售商品类目", trigger: "change" }
  ],
  company_description: [
    { required: true, message: "请输入公司介绍", trigger: "blur" }
  ],
  email: [
    { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" }
  ],
};
const dataHandle = (data: any) => {
  let returnData: { name: string; id: number }[] = [];
  const keys = Object.keys(data);
  const values = Object.values(data);
  keys.forEach((key, index) => {
    const data = {
      name: key,
      id: values[index] as number,
    };
    returnData.push(data);
  });
  return returnData;
};
const getAreaHandle_receive = (type, data: any = {}) => {
  if (type === "province") {
    API_goods.getJDProvince().then((res) => {
      provinceList.value = dataHandle(res.data.result);
    });
  } else if (type === "city") {
    API_goods.getJDCity(data.id).then((res) => {
      cityList.value = dataHandle(res.data.result);
    });
  } else if (type === "county") {
    API_goods.getJDCounty(data.id).then((res) => {
      countyList.value = dataHandle(res.data.result);
    });
  } else if (type === "town") {
    API_goods.getJDTown(data.id).then((res) => {
      townList.value = dataHandle(res.data.result);
    });
  }
};
getAreaHandle_receive("province");
const changeProvince = (type: string) => {
  formRef.value.validateField("office_address_info");
  if (type == "province") {
    address.value.receive_city_id = ""; //上门取件市id
    address.value.receive_city = ""; //上门取件市
    address.value.receive_county_id = ""; //上门取件区id
    address.value.receive_county = ""; //上门取件区
    address.value.receive_town_id = ""; //上门取件镇id
    address.value.receive_town = ""; //上门取件镇
    if (address.value.receive_province_id === "") {
      (address.value.receive_province = ""), //上门取件省
        getAreaHandle_receive("province");
    } else {
      const findProvince = provinceList.value.find(
        (item) => item.id === Number(address.value.receive_province_id)
      );

      address.value.receive_province = findProvince!.name; //上门取件省
      getAreaHandle_receive("city", {
        id: address.value.receive_province_id,
      });
    }
  } else if (type == "city") {
    address.value.receive_county_id = ""; //上门取件区id
    address.value.receive_county = ""; //上门取件区
    address.value.receive_town_id = ""; //上门取件镇id
    address.value.receive_town = ""; //上门取件镇
    if (address.value.receive_province_id === "") return;
    if (address.value.receive_city_id !== "") {
      const findCity = cityList.value.find(
        (item) => item.id === Number(address.value.receive_city_id)
      );
      address.value.receive_city = findCity!.name; //上门取件市
      getAreaHandle_receive("county", {
        id: address.value.receive_city_id,
      });
    }
  } else if (type == "county") {
    address.value.receive_town_id = "";
    if (address.value.receive_city_id === "") return;
    if (address.value.receive_county_id !== "") {
      const findCounty = countyList.value.find(
        (item) => item.id === Number(address.value.receive_county_id)
      );
      address.value.receive_county = findCounty!.name; //上门取件区
      getAreaHandle_receive("town", {
        id: address.value.receive_county_id,
      });
    }
  } else if (type == "town") {
    address.value.receive_town = ""; //上门取件县
    if (address.value.receive_town_id === "") return;
    if (address.value.receive_town_id !== "") {
      const findTown = townList.value.find(
        (item) => item.id === Number(address.value.receive_town_id)
      );
      address.value.receive_town = findTown!.name; //上门取件县
    }
  }
};

const formValidate = async () => {
  await formRef.value?.validate?.()
  const { receive_province = '', receive_city = '', receive_county = '', receive_town = '' } = address.value;
  form.value.office_address = `${receive_province}${receive_city}${receive_county}${receive_town}`;
  const data = { ...form.value }
  return data;
}

expose({
  formValidate
})

return { __sfc: true,fileUrl, fileName, loading, dialogImageUrl, dialogImage, handlePictureCardPreview, getShop, openFile, downloadFile, formRef, provinceList, cityList, countyList, townList, address, prop, form, rules, dataHandle, getAreaHandle_receive, changeProvince, formValidate }
}

})